import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import axios from 'axios'

function e164(raw) {
  const digits = String(raw || '').replace(/\D+/g, '')
  if (digits.startsWith('251')) return `+${digits}`
  if (digits.startsWith('0')) return `+251${digits.slice(1)}`
  if (digits.length === 9) return `+251${digits}`
  return `+${digits}`
}

export default {
  e164,
  digits(raw) {
    return e164(raw).replace(/\D+/g, '')
  },
  async sendOtp(phone) {
    const formatted = e164(phone)
    const res = await axios.post('/auth/send-phone-otp', { phone: formatted })
    return { channel: 'sms', confirmation: null, phone: res.data.phone || formatted }
  },
  async confirmOtp(session, code) {
    if (session.channel === 'firebase' && session.confirmation) {
      await session.confirmation.confirm(code)
      return { firebase: true }
    }
    await axios.post('/auth/verify-phone-otp', { phone: session.phone, otp: code })
    return { firebase: false }
  },
  aliasEmail(phone) {
    return `${this.digits(phone)}@phone.ridelilo.com`
  },
  async ensureFirebaseUser(session, email, password) {
    if (firebase.auth().currentUser) {
      return firebase.auth().currentUser.getIdToken(true)
    }
    const mail = email || this.aliasEmail(session.phone)
    const pass = password || `Lilo${this.digits(session.phone).slice(-6)}Aa`
    try {
      const created = await firebase.auth().createUserWithEmailAndPassword(mail, pass)
      return created.user.getIdToken(true)
    } catch (error) {
      if (error.code === 'auth/email-already-in-use') {
        const signed = await firebase.auth().signInWithEmailAndPassword(mail, pass)
        return signed.user.getIdToken(true)
      }
      throw error
    }
  },
  storeToken(token) {
    const fresh = String(token).includes('|') ? token.split('|')[1] : token
    localStorage.setItem('freshToken', fresh)
    axios.defaults.headers.common.Authorization = `Bearer ${fresh}`
    return fresh
  },
}
